export default "__VITE_ASSET__Crfrf14D__"